<template>
  <div v-if='data' class='data-content'>
    <audio v-if='data.type == 11' :src='`data:audio/mpeg;base64,${this.data.value}`' controls />
    <img v-if='data.type == 12' :src='`data:image/png;base64,${this.data.value}`' />
    <pre v-if='data.type != 11 && data.type != 12 && data.value !== undefined'>{{data.value}}</pre>
  </div>
</template>

<script>
export default {
  name: 'ContentNode',
  props: { path: String },
  computed: {
    data() {
      return this.$store.state.paths[this.path]
    }
  }
}
</script>

<style scoped>
.data-content > * {
  background: rgba(0, 0, 0, 0.1);
  padding: 8px;
  box-shadow: 0 0 2px black;
}
</style>